import React, { useState, useEffect } from "react";
import { Card, Typography, Button, Table, Menu, Space } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import translator from "@/translator";
import SubscriptionCard from "@/note_office/shared/SubscriptionCard";
import { Next } from "@/note_office/icons/menu";
import { PlusOutlined } from "@ant-design/icons";
import Calendar from "@/note_office/icons/Calendar2";
import Sort from "@/note_office/icons/Sort";
import LoadingWrapper from "@/components/LoadingWrapper";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useSubState } from "../State.js";

const { Text } = Typography;

const t = translator("note_office.views.subscriptions.index_view.payments_history.");

const PaymentsHistory = ({}) => {
  const { state } = useSubState();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [paymentsData, setPaymentsData] = useState([]);
  let [searchParams, _] = useSearchParams();

  const [currentPerPage, setCurrentPerPage] = useState(searchParams.get("per_page") || 20);
  const [currentPage, setCurrentPage] = useState(searchParams.get("page") || 1);
  const [filterParams, setFilterParams] = useState({});

  const fetchTableData = () => {
    setIsLoading(true);

    const params = {
      page: currentPage,
      per_page: currentPerPage,
      q: filterParams,
    };

    axios("/note_office/payments", {
      params: params,
      headers: { Accept: "application/json" },
    })
      .then(({ data }) => {
        setPaymentsData(data.payments);
      })
      .catch((_error) => {
        setPaymentsData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const columns = [
    {
      title: t("table.columns.created_at"),
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: t("table.columns.sum"),
      dataIndex: "sum",
      key: "sum",
    },
    {
      title: t("table.columns.operation_type"),
      dataIndex: "operation_type",
      key: "type",
    },
  ];

  const changeTariffSetting = [
    {
      key: "settings",
      label: (
        <div className="profile__menu-item" onClick={() => navigate("/new")}>
          <span className="profile__menu-link">{t("tariff_settings")}</span>
          <span className="profile__menu-arrow">
            <Next />
          </span>
        </div>
      ),
    },
  ];

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <div className="subscriptions__index">
        <Space className="contacts-show__back">
          <BackButton link={state.profile_url} title={t("title")} />
        </Space>

        <div className="subscriptions__index-content">
          <div className="profile__card subscriptions__card">
            <SubscriptionCard
              sub_name={state.customer_current_sub_plan.name}
              sub_paid_until={state.sub_paid_until}
            />
          </div>

          <Menu
            mode="vertical"
            items={changeTariffSetting}
            className="profile__menu profile__menu-margin"
            selectedKeys={[]}
          />

          <Text className="subscriptions__label">SMS</Text>

          <div className="profile__card sms__card">
            <Card className="tariff-card">
              <div className="tariff-card__header">
                <p type="secondary" className="tariff-card__text">
                  {t("balance")}
                </p>

                <Button
                  type="default"
                  className="tariff-card__badge"
                  icon={<PlusOutlined />}
                  onClick={() => navigate("/sms/new")}
                >
                  {t("recharge")}
                </Button>
              </div>
              <h2 className="tariff-card__title">{state.balance}</h2>
            </Card>
          </div>

          <div className="subscriptions__label-container">
            <Text className="subscriptions__label">{t("payment_history")}</Text>
            <Calendar />
          </div>

          <div className="subscriptions__sort">
            <Sort />
          </div>

          <div className="subscriptions__table">
            <LoadingWrapper loading={isLoading}>
              <Table
                columns={columns}
                dataSource={paymentsData}
                pagination={{ pageSize: 5 }}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </LoadingWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsHistory;
